// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qmncgmrafwvhmsjhnyzc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFtbmNnbXJhZnd2aG1zamhueXpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjkyMTY4ODUsImV4cCI6MjA4NDc5Mjg4NX0.iXqCClUJZawAaOrttyxD6be_Y2xqCVMv02cN60MDiv8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});